export default "__VITE_PUBLIC_ASSET__09f92366__"